import { render, staticRenderFns } from "./AdminGetResetPassword.vue?vue&type=template&id=0cfce320&"
import script from "./AdminGetResetPassword.vue?vue&type=script&lang=ts&"
export * from "./AdminGetResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports